import { put, takeLatest, all, select, fork } from 'redux-saga/effects';
import { PRINT_OFFER, SEARCH_CUSTOMER} from './constants';
import { SEND_QUOTE } from 'containers/Offer/constants';
import { makeSelectPrintFrom, makeSelectCustomerCode } from './selectors';
import { getRequestHeadersAsLogged, responseHandler } from '../../utils/auth';
import { customerLoaded } from './actions';
import { open } from '../Modal/actions';
import { makeSelectQuote } from '../CarQuote/selectors';
import { quoteSended } from '../CarQuote/actions';

function* printOffer() {
  const printer = yield select(makeSelectPrintFrom());
  const requestURL = `${process.env.API_URL}offers/attachment`;

  try {
    const parameters = {
      method: 'POST',
      headers: getRequestHeadersAsLogged(),
      body: JSON.stringify(printer),
    };

    const request = yield fetch(requestURL, parameters).then(response =>
      response.blob(),
    ).then(blob => {
      const date = new Date();
      return download(blob, `Preventivo-${date.getTime()}`);
    });

  } catch (err) {
    console.log('request error', err);
  }
}

function* searchCustomer() {
  const code = yield select(makeSelectCustomerCode());
  const requestURL = `${process.env.API_URL}customers/search?code=${code}`;

  try {
    const parameters = {
      method: 'GET',
      headers: getRequestHeadersAsLogged(),
    };

    const request = yield fetch(requestURL, parameters).then(response =>
      responseHandler(response)
    );
    yield put(customerLoaded(request.data));
    yield put(open());
  } catch (err) {
    yield put(customerLoaded({}));
    yield put(open());
  }
}

function* sendQuoteData() {
  const quote = yield select(makeSelectQuote());
  const requestURL = `${process.env.API_URL}quote`;

  try {
    const parameters = {
      method: 'POST',
      headers: getRequestHeadersAsLogged(),
      body: JSON.stringify(quote),
    };

    const request = yield fetch(requestURL, parameters).then(response =>
      responseHandler(response)
    );

    yield put(quoteSended(request.data));

  } catch (err) {
    console.log('request error', err);
  }
}


function* actionWatcher() {
  //yield takeLatest(PRINT_OFFER, printOffer);
  yield fork(takeLatest, PRINT_OFFER, printOffer);
  yield takeLatest(SEARCH_CUSTOMER, searchCustomer);
  yield takeLatest(SEND_QUOTE, sendQuoteData);
}

export default function* formsData() {
  yield all([actionWatcher()]);
}
